<template>
  <div class="text-center pa-lg-6">
    <v-card
      v-if="value.resource"
      :href="resourceHref(value)"
      color="background"
      rounded="0"
      variant="flat"
    >
      <ImageCover
        v-if="isArticle(value)"
        :value="value.resource"
        content-class="d-flex align-end"
        default-key="article_default_image"
      >
        <v-btn
          :append-icon="mdiArrowRight"
          class="text-capitalize ma-3"
          color="secondary"
          exact
          position="absolute"
          rounded="pill"
          style="top: 0; right: 0"
          >Read</v-btn
        >

        <v-card-text
          v-if="value.resource.title"
          class="text-body-1 bg-light-blue-darken-2"
        >
          <h6 class="text-subtitle-1 text-uppercase font-weight-bold mb-2">
            {{ resourceType(value) }}
          </h6>
          <p class="text-body-1 text-truncate-2 mb-2">
            {{ value.resource.title }}
          </p>
        </v-card-text>
      </ImageCover>

      <ImageCover
        v-else-if="isCaseStudy(value)"
        :value="value.resource"
        content-class="d-flex align-end"
        default-key="download_default_image"
      >
        <v-btn
          :append-icon="mdiArrowRight"
          class="text-capitalize ma-3"
          color="secondary"
          exact
          position="absolute"
          rounded="pill"
          style="top: 0; right: 0"
          >Read</v-btn
        >

        <v-card-text
          v-if="value.resource.title"
          class="text-body-1 bg-light-blue-darken-2"
        >
          <h6 class="text-subtitle-1 text-uppercase font-weight-bold mb-2">
            {{ resourceType(value) }}
          </h6>
          <p class="text-body-1 text-truncate-2 mb-2">
            {{ value.resource.title }}
          </p>
        </v-card-text>
      </ImageCover>

      <ImageCover
        v-else-if="isDownload(value)"
        :value="value.resource"
        content-class="d-flex align-end"
        default-key="download_default_image"
      >
        <v-btn
          :append-icon="mdiArrowRight"
          class="text-capitalize ma-3"
          color="secondary"
          exact
          position="absolute"
          rounded="pill"
          style="top: 0; right: 0"
          >Download</v-btn
        >

        <v-card-text
          v-if="value.resource.title"
          class="text-body-1 bg-light-blue-darken-2"
        >
          <h6 class="text-subtitle-1 text-uppercase font-weight-bold mb-2">
            {{ resourceType(value) }}
          </h6>
          <p class="text-body-1 text-truncate-2 mb-2">
            {{ value.resource.title }}
          </p>
        </v-card-text>
      </ImageCover>

      <ImageCover
        v-else-if="isFaq(value)"
        :value="value.resource"
        content-class="d-flex align-end"
      >
        <v-btn
          :append-icon="mdiArrowRight"
          class="text-capitalize ma-3"
          color="secondary"
          exact
          position="absolute"
          rounded="pill"
          style="top: 0; right: 0"
          >Read</v-btn
        >

        <v-card-text
          v-if="value.resource.faq.question_text"
          class="text-body-1 bg-light-blue-darken-2"
        >
          <h6 class="text-subtitle-1 text-uppercase font-weight-bold mb-2">
            {{ resourceType(value) }}
          </h6>
          <p class="text-body-1 text-truncate-2 mb-2">
            {{ value.resource.faq.question_text }}
          </p>
        </v-card-text>
      </ImageCover>

      <VideoCover
        v-else-if="isVideo(value)"
        :value="value.resource"
        content-class="d-flex align-end"
      >
        <v-btn
          :append-icon="mdiArrowRight"
          class="text-capitalize ma-3"
          color="secondary"
          exact
          position="absolute"
          rounded="pill"
          style="top: 0; right: 0"
          >Watch</v-btn
        >

        <v-card-text v-if="value.resource.title" class="bg-light-blue-darken-2">
          <h6 class="text-subtitle-1 text-uppercase font-weight-bold mb-2">
            {{ resourceType(value) }}
          </h6>
          <p class="text-body-1 text-truncate-2 mb-2">
            {{ value.resource.title }}
          </p>
        </v-card-text>
      </VideoCover>
    </v-card>

    <v-btn
      :append-icon="mdiArrowRight"
      :href="resourceHref(value, true)"
      class="mt-3"
      variant="text"
    >
      View All {{ resourceType(value, true) }}
    </v-btn>
  </div>
</template>

<script setup>
import {
  isArticle,
  isCaseStudy,
  isDownload,
  isFaq,
  isVideo,
  resourceHref,
  resourceType
} from '#root/lib/utils'
import { mdiArrowRight } from '@mdi/js'

defineProps({
  value: {
    required: true,
    type: Object
  }
})
</script>
